<template>
    <!-- Add Account Modal -->
     
    <div class="modal worli-Bets-Modal" id="acc-open-model" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{$t('add-account', 'Add account')}}</h5>
                    <button type="button" @click="clearError()" id="closeBtn" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body add_bank_acc_form">
                    <div class="p-0">
                        <div class="acc-login-form-sec" v-if="paymentMethodList">
                            <label>{{ $t('payment-method', 'Payment Method') }}</label>
                            <select @change="onPaymentMethodChange()" v-model="paymentMethodId" class="form-select form-control">
                                <option value="null">---{{ $t('select-payment-method', 'Select Payment Method') }}---</option>
                                <option v-for="(item, index) in paymentMethodList" :key="index" :value="item.id" >{{ item.method_name }}</option>
                            </select>
                        </div>
                            
                        <template v-if="type === 'bank'">
                            <div class="acc-login-form-sec" v-if="filteredBankList">
                            <div class="select-payment-list">
                                <div class="dropdown bank-dropdown">
                                    <button class="bank-dropdown-input" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                    {{  selectedBank ? selectedBank : $t('select-bank-name', 'Select Bank Name') }}
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <div class="wallet-search-input">
                                            <input type="search" v-model="searchBank" class="form-control" :placeholder="$t('search-banks','Search Banks...')">
                                            <button type="button" class="search-bank-close-btn">
                                                <img src="@/assets/images/close.webp" alt="">
                                            </button>
                                        </div>
                                        <template v-if="filteredBankList && filteredBankList.length">
                                            <li v-for="(item, index) in filteredBankList" :key="index">
                                                <a class="dropdown-item" @click="selectBank(item)">{{ item.bank_name }}</a>
                                            </li>
                                        </template>
                                        <li v-else>
                                            <a class="dropdown-item">{{$t('no-data-found','No data found')}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <p v-if="v$.accountForm.bankId.$error" class="error">{{ $t('please-select-bank-name', 'Please Select Bank Name') }}.</p>
                        </div>
                            <div class="acc-login-form-sec">
                                <input type="text" v-model="accountForm.account_holder_name" :placeholder="$t('enter-account-holder-name', 'Enter Account Holder Name')+'*'" class="form-control">
                                <div v-if="v$.accountForm.account_holder_name?.$error && accountForm.account_holder_name == ''" class="error" for="nameInput">
                                    {{$t('please-enter-name','Account holder name is required.')}}
                                </div>
                                <div v-else-if="v$.accountForm.account_holder_name?.$error && (v$.accountForm.account_holder_name?.minLength.$invalid || v$.accountForm.account_holder_name?.maxLength.$invalid)" class="error" for="nameInput">
                                    {{$t('min-characters','Account holder name must be 3-100 characters.')}}
                                </div>
                                <div v-if="v$.accountForm.account_holder_name?.$error && v$.accountForm.account_holder_name?.alphaName.$invalid" class="error" for="nameInput">
                                    {{$t('only-letters','Must contain only alphabets, spaces, dots, or hyphens.')}}
                                </div>
                            </div>
                            <div class="acc-login-form-sec">
                                <input v-model="accountForm.account_no" @input="validateAccNumber()" maxlength="18" type="text" :placeholder="$t('enter-ac-Number', 'Enter A/C Number')+'*'" class="form-control">
                                <div v-if="v$.accountForm.account_no.$error && accountForm.account_no == ''" class="error" for="nameInput">
                                    {{ $t('please-enter-ac-number', 'Account number is required') }}.
                                </div>
                                <div v-else-if="v$.accountForm.account_no.$error && accountForm.account_no != ''" class="error" for="nameInput">
                                    Account Number must be a valid numeric value between 9 to 18 digits
                                </div>
                            </div>
                            <div class="acc-login-form-sec">
                                <input v-model="accountForm.ifsc_code" type="text" @input="validateIFSC()" :placeholder="$t('enter-ifsc-code', 'Enter IFSC Code')+'*'" class="form-control">
                                <div v-if="v$.accountForm.ifsc_code.$error && accountForm.ifsc_code == ''" id="ifscCodeInput-error" class="error" for="ifscCodeInput">
                                    {{ $t('please-enter-ifsc-code', 'IFSC Code is required') }}.
                                </div>
                                <div v-if="v$.accountForm.ifsc_code.$error && v$.accountForm.ifsc_code?.ifscValidator.$invalid" id="ifscCodeInput-error" class="error" for="ifscCodeInput">
                                    IFSC code should be 11 alphanumeric characters.
                                </div>
                            </div>
                        </template>
                        <template v-if="type === 'upi' || type === 'wallet'">
                            <div class="acc-login-form-sec">
                                <input v-model="accountForm.account_holder_name"  type="text" class="form-control" :placeholder="$t('enter-account-holder-name', 'Enter Account Holder Name')+'*'"/>
                                <div v-if="v$.accountForm.account_holder_name?.$error && accountForm.account_holder_name == ''" class="error" for="nameInput">
                                    {{$t('please-enter-name','Account holder name is required.')}}
                                </div>
                                <div v-else-if="v$.accountForm.account_holder_name?.$error && (v$.accountForm.account_holder_name?.minLength.$invalid || v$.accountForm.account_holder_name?.maxLength.$invalid)" class="error" for="nameInput">
                                    {{$t('min-characters','Account holder name must be 3-100 characters.')}}
                                </div>
                                <div v-if="v$.accountForm.account_holder_name?.$error && v$.accountForm.account_holder_name?.alphaName.$invalid" class="error" for="nameInput">
                                    {{$t('only-letters','Must contain only alphabets, spaces, dots, or hyphens.')}}
                                </div>
                            </div>


                            <template v-if="type === 'upi'">
                                <div class="acc-login-form-sec">
                                    <input v-model="accountForm.upi_id" class="form-control profit-input" type="text" :placeholder="$t('enter-upi-id', 'Enter UPI ID')">
                                    <div class="error" v-if="accountForm.upi_id != '' && v$.accountForm.upi_id.$error && v$.accountForm.upi_id.minLength.$invalid || v$.accountForm.upi_id.maxLength.$invalid">
                                        {{  $t('upi-length','UPI ID must be 5 to 50 characters.')  }}
                                    </div>
                                    <div class="error" v-if="accountForm.upi_id != '' && v$.accountForm.upi_id.$error && v$.accountForm.upi_id.upiValidator.$invalid">
                                        {{$t('upi-format','Must be in the format of name@bank.')}}
                                    </div>
                                </div>
                            </template>

                            <template v-if="type === 'wallet'">
                                <div class="acc-login-form-sec">
                                    <input v-model="accountForm.walletId" class="form-control profit-input" type="text" :placeholder="$t('enter-wallet-id', 'Enter wallet ID')+'*'">
                                    <div class="error" v-if="v$.accountForm.walletId.$error && accountForm.walletId == ''">
                                        {{ $t('upi-required','Wallet ID is required.')  }}
                                    </div>
                                    <div class="error" v-else-if="v$.accountForm.walletId.$error && v$.accountForm.walletId.minLength.$invalid || v$.accountForm.walletId.maxLength.$invalid">
                                        {{ $t('wallet-length','Wallet ID must be 8 to 20 characters.') }}
                                    </div>
                                    <div class="error" v-if="v$.accountForm.walletId.$error && v$.accountForm.walletId.walletValidator.$invalid">
                                        {{$t('wallet-format','Must contain only letters, numbers, @, hyphens, or underscores.')}}
                                    </div>
                                </div>
                            </template>

                            <div class="acc-login-form-sec wrdl-file-uploaded-wrapper">
                                <div class="file-upload-sec add-acc-file-uploaded-sec" v-if="!previewImg">
                                    <label for="file"  class="file-upload">
                                        <span><img src="@/assets/images/file-icon.webp" alt="file-icon" loading="lazy"></span>
                                        <h6>{{ $t('file-upload', 'File Upload') }}</h6>
                                    </label>
                                    <span class="info-sec-icon">
                                        <img src="@/assets/images/info-icon.svg" alt="info-icon" loading="lazy">
                                        <div class="info-list">
                                            <ul>
                                                <li>1. {{ $t('tap-your-profile', 'Upload a screenshot of a valid QR code to proceed') }}.</li>
                                                <li>2. {{ $t('tap-qr-code', 'If QR code is not detected, Exchange will not be responsible for the losses') }}.</li>
                                            </ul>
                                        </div>
                                    </span>
                                    <input class="form-control profit-input d-none" ref="fileInput" type="file" id="file"  @change="fileUpdateFunc">
                                </div>
                                <div class="file-uploaded" v-if="previewImg">
                                    <img loading="lazy" class="file-uploaded-img" :src="previewImg" alt="file-list"/>
                                    <!-- <span class="file-uploaded-title">{{ accountForm.file.name }}</span> -->
                                    <span class="file-uploaded-cross" @click="removeFile">&#10006;</span>
                                </div>
                            </div>
                        </template>
                        <div class="acc-login-form-sec" v-if="type">
                            <div class="fill_con">
                                <input :type="passwordFieldType"  v-model="accountForm.withdrawal_password" @input="accountForm.withdrawal_password = $helper.sanitizeDetails('withdrawPassword', accountForm.withdrawal_password, 20)"  
                                :placeholder="$t('enter-withdrawal-password', 'Enter Withdrawal Password')+'*'" class="form-control profit-input" />
                                <div class="showHide-icon" @click="togglePasswordVisibility('passwordField')">
                                    <i v-if="passwordFieldType === 'password'" aria-hidden="true" class="fa fa-eye-slash"></i>
                                    <i v-else aria-hidden="true" class="fa fa-eye"></i>
                                </div>
                            </div>
                            <div v-if="v$.accountForm.withdrawal_password.$error" class="error" for="nameInput">{{ $t('please-enter-withdraw-password', 'Enter Withdraw Password') }}</div>
                        </div>
                        <div class=" forget-pass-link">
                            <a href="javascript:void(0)" class="blue-link mt-1" @click="openWithdrawPassModal()">{{$t('forgot-withdraw-password','Forgot Withdraw Password')}}?</a>
                        </div>
                    </div>
                    <div class="footer-buttonWrap">
                        <button type="button" class="buttonWrap-btn buttonCancel save_stake_btn123" data-bs-dismiss="modal" @click="clearError()" >{{$t('cancel', 'Cancel')}}</button>
                        <button class="buttonWrap-btn buttonTheme save_stake_btn123" @click="addAccountServiceCall()">{{$t('save', 'Save')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { useVuelidate } from '@vuelidate/core';
import { required, minLength, maxLength, helpers } from '@vuelidate/validators';
import {addAccount} from '../services/withdrawAccountDetails';
const alphaName = helpers.withMessage(
  'Must contain only alphabets, spaces, dots, or hyphens.',
  (value) => {
    if (value === null || value === undefined || value === '') return true
    const s = String(value)
    return /^[A-Za-z .-]+$/.test(s)
  }
)
const ifscValidator = helpers.withMessage(
  "It should be 11 alphanumeric characters.",
  (value) => {
    if (!value) return true
    return /^[A-Z0-9]{11}$/.test(String(value))
  }
)
const upiValidator = helpers.withMessage(
  "Must be in the format of 'name@bank.'",
  (value) => {
    if (!value) return true
    return /^[A-Za-z0-9]+@[A-Za-z0-9]+$/.test(String(value))
  }
)
const walletValidator = helpers.withMessage(
  'Must contain only letters, numbers, @, hyphens, or underscores.',
  (value) => {
    if (value === null || value === undefined || value === '') return true
    return /^[A-Za-z0-9@_-]+$/.test(String(value))
  }
)
export default {
    name: 'AddBankAccount',
    setup() {
		return { v$: useVuelidate() }
	},
    props:{
        getAccountDetailList: Function,
        paymentMethodList:Array
    },
    emits:['getAccountDetailList'],
    inject:['walletConfig'],
    data() {
        return {
            loading: false,
            paymentMethodId: null,
            type: null,
            bankDetailsList: null,
            accountForm: {
				bankId: null,
				account_holder_name: '',
				account_no: '',
				ifsc_code: '',
				upi_id: '',
				walletId: '',
				file: null,
                withdrawal_password: null
			},
            passwordFieldType: 'password',
            searchBank:null,
            selectedBank:null,
            previewImg:null,
            paymentMethod: null
        }
    },
    mounted(){
        this.bankDetailsList = this.walletConfig?.bank_list
        document.addEventListener('click', this.handleClickOutside);
    },
    computed: {
        filteredBankList() {            
            if(this.searchBank) {
                const searchTermLower = this.searchBank?.toLowerCase();
                return this.bankDetailsList.filter(item => item.bank_name?.toLowerCase().includes(searchTermLower));
            }
            return this.bankDetailsList
        }
    },
    validations() {
        return {
            accountForm: {
                bankId: this.type === 'bank' ? { required } : {},
                account_holder_name: { required, minLength: minLength(3),
                    maxLength: maxLength(100),
                    alphaName },
                account_no: this.type === 'bank' ? { 
                    required, 
                    minLength: minLength(9),
                    maxLength: maxLength(18) } : {},
                ifsc_code: this.type === 'bank' ? { required, ifscValidator } : {},
                upi_id: this.type === 'upi' ? { 
                    minLength: minLength( 5 ),
                    maxLength: maxLength( 50 ),
                    upiValidator  } : {},
                walletId: this.type === 'wallet' ? { 
                    required,
                    required,
                    minLength: minLength( 8),
                    maxLength: maxLength( 20),
                    walletValidator } : {},
                withdrawal_password: { required },

            }
        };
    },
    methods: {
        validateIFSC(){
            this.accountForm.ifsc_code  = this.accountForm.ifsc_code.toUpperCase()
        },
        handleClickOutside() {
            this.searchBank = null;
        },
        removeFile() {
            this.accountForm.file = null;
            this.previewImg = null;
        },
        selectBank(item){
            this.accountForm.bankId = item.id
            this.selectedBank = item.bank_name
            this.searchBank = ''
        },
        onPaymentMethodChange(item) {
            this.clearForm();
            const selectedItem = this.paymentMethodList.find(item => item.id === this.paymentMethodId);
            this.getPaymentMethodItem(selectedItem);
            this.paymentMethod = selectedItem
            console.log(selectedItem)
        },
        getPaymentMethodItem(item) {
            this.type = item?.method_type;
            this.accountForm.paymentMethodId = item.id;
		    this.accountForm.paymentTypeName = item.name;
        },
        async addAccountServiceCall() {    
            this.accountForm.account_holder_name = this.accountForm?.account_holder_name?.trim()        
            this.v$.$touch()
            if (this.v$.$error) {
                return
            }
            if(this.type === 'upi' && this.accountForm.upi_id == '' && this.accountForm.file == null){
                this.$errorToast('At least one field is required UPI ID or QR code.')
                return false;
            }
            let response = await addAccount(this.paymentMethod, this.type, this.accountForm, this.accountForm)
            if(response){
                this.clearError();  
                this.getAccountDetailList()
                this.$helper.closeModal('acc-open-model')
            }
        },
        validateAccNumber(){
            this.accountForm.account_no  = this.accountForm.account_no.replace(/\D/g, '')
        },
        fileUpdateFunc(event) {
            try {
                const file = event.target.files[0];
                if (!file.type.startsWith('image/')) {
                    this.$errorToast('Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB.');
                    return;
                }
                const maxSize = 5 * 1024 * 1024; 
                if (file.size > maxSize) {
                    this.$errorToast('Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB.');
                    return;
                }
                this.accountForm.file = file;
                this.previewImg = URL.createObjectURL(this.accountForm.file);
            } catch (e) {
                this.$errorToast(this.$t('try-again-with-different-image', 'Try again with a different image!'));
            }
        },
        clearForm(){
            this.accountForm = {
				bankId: null,
				account_holder_name: '',
				account_no: '',
				ifsc_code: '',
				upi_id: '',
				walletId: '',
				file: null
			},
            this.previewImg = null,
            this.type = null,
            this.errors = {};
            this.selectedBank = null;
            this.searchBank=null,
            this.v$.$reset();
            this.passwordFieldType = 'password'
        },
        clearError() {
            this.clearForm()
            this.paymentMethodId = null
        },
         openWithdrawPassModal() {
            this.$emit('open-withdraw-password-modal');
        },
        togglePasswordVisibility() {
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
        }
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    },
};
</script>
<style scoped>
.btn-disabled{
  pointer-events: none;
  opacity: 0.5;
}
</style>